import Localize from 'react-intl-universal';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import ShowInterestHeader from './ShowInterstHeader';

export const StyledCustomDialog = styled(Dialog)(({ theme }) => ({
  height: '45rem',
  margin: 'auto',
  overflowY: 'scroll',
  overflowX: 'hidden',
  '& .MuiDialog-paper': {
    backgroundColor: `${theme.palette.booking.background}!important`,
    [theme.breakpoints.up('xs')]: { width: '100%', margin: '0.5rem' }
  }
}));

const StyledCancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: '700',
  color: theme.palette.primary.main
}));

const StyledAlert = styled(Alert)(({ theme }) => ({
  color: theme.palette.booking.confirmationText,
  backgroundColor: theme.palette.booking.confirmation,
  display: 'inline-flex',
  marginBottom: '1rem',
  fontSize: '1rem !important'
}));

const ConfirmationDialog = ({
  event,
  showSnackbar,
  setShowSnackbar,
  hasErrorMessage,
  setHasErrorMessage
}) => {
  return (
    <StyledCustomDialog
      open={showSnackbar}
      onClose={() => {
        setShowSnackbar(false);
        setHasErrorMessage(false);
      }}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth={true}
      maxWidth='md'
    >
      <DialogTitle id='alert-dialog-title' sx={{ paddingBottom: '0.3rem' }}>
        <ShowInterestHeader eventData={event} availableSeats={event?.availableSeats || 0} />
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 0,
          pl: { xs: '0.5rem', sm: '3.5rem' },
          pr: { xs: '0.5rem', sm: '3.5rem' },
          pb: 4,
          fontSize: '1rem',
          minHeight: '10rem'
        }}
      >
        {hasErrorMessage ? (
          <>
            <Typography sx={{ mb: 2, textAlign: { xs: 'center', sm: 'left' } }} variant='h5'>
              {Localize.get('EventDetails.showInterestFailed')}
            </Typography>
            {hasErrorMessage?.message && (
              <Typography
                sx={{ mb: 2, textAlign: { xs: 'center', sm: 'left', color: 'red' } }}
                variant='h6'
              >
                {hasErrorMessage?.message}
              </Typography>
            )}
          </>
        ) : (
          <>
            <Typography sx={{ mb: 2, textAlign: { xs: 'center', sm: 'left' } }} variant='h5'>
              {Localize.get('EventDetails.showInterest')}
            </Typography>
            <StyledAlert icon={false} severity='success'>
              {Localize.get('Booking.confirmationEmailFirst', { eventName: `${event.name}` })}
            </StyledAlert>
            <Typography>{Localize.get('EventDetails.showInterestSuccessful')}</Typography>
          </>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: (theme) => theme.palette.common.white,
          justifyContent: { xs: 'center', md: 'flex-end' }
        }}
      >
        <StyledCancelButton onClick={() => setShowSnackbar(false)}>
          {Localize.get('App.close')}
        </StyledCancelButton>
      </DialogActions>
    </StyledCustomDialog>
  );
};

export default ConfirmationDialog;
